(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kierin-fragrance-quiz"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kierin-fragrance-quiz')) {
  customElements.define('kierin-fragrance-quiz', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.intro = this.querySelector('[data-intro]');
      this.form = this.querySelector('[data-form]');
      this.results = this.querySelector('[data-results]');
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.index = 0;
      this.cards = [...this.querySelectorAll('[data-match]')];
      this.querySelector('[data-start]').hidden = false;
      this.querySelector('[data-start]').addEventListener('click', () => this.showStep(0));
      this.querySelector('[data-back]').addEventListener('click', () => {
        if (this.index > 0) this.showStep(this.index - 1);
        else {
          this.form.hidden = true;
          this.intro.hidden = false;
          this.querySelector('[data-start]').focus();
        }
      });
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (!this.steps[this.index].querySelector('input:checked')) {
          this.steps[this.index].querySelector('input').reportValidity();
          return;
        }
        if (this.index < this.steps.length - 1) this.showStep(this.index + 1);
        else this.showResults();
      });
      this.querySelector('[data-edit]').addEventListener('click', () => this.showStep(0));
      this.querySelector('[data-restart]').addEventListener('click', () => {
        this.form.reset();
        this.showStep(0);
      });
    }
    showStep(index) {
      this.index = index;
      this.intro.hidden = true;
      this.results.hidden = true;
      this.form.hidden = false;
      this.steps.forEach((step, i) => { step.hidden = i !== index; step.disabled = i !== index; });
      this.querySelector('[data-progress]').textContent = this.labels.progress[index];
      this.querySelector('[data-next]').textContent = index === this.steps.length - 1 ? this.labels.results : this.labels.next;
      this.steps[index].querySelector('legend').focus();
    }
    showResults() {
      const answers = this.steps.map(step => step.querySelector('input:checked')?.value);
      if (answers.some(answer => !answer)) { this.showStep(answers.findIndex(answer => !answer)); return; }
      const cards = this.cards;
      const dimensions = ['direction', 'mood', 'texture'];
      const weights = [5, 3, 2];
      const ranked = cards.map((card, index) => ({card, index, score: dimensions.reduce((sum, dimension, i) => sum + (card.dataset[dimension].split(' ').includes(answers[i]) ? weights[i] : 0), 0)})).sort((a, b) => b.score - a.score || a.index - b.index);
      cards.forEach(card => {
        card.hidden = true;
        const link = card.querySelector('[data-match-link]');
        if (link) {
          const travel = answers[3] === 'travel' && link.dataset.travelUrl;
          link.href = travel ? link.dataset.travelUrl : link.dataset.productUrl;
          link.textContent = travel ? link.dataset.travelLabel : link.dataset.productLabel;
        }
      });
      this.querySelectorAll('[data-format-note]').forEach(note => { note.hidden = note.dataset.formatNote !== answers[3]; });
      ranked.slice(0, 3).forEach(({card}) => { card.hidden = false; this.querySelector('.kfq-matches').append(card); });
      this.querySelector('[data-empty]').hidden = cards.length > 0;
      this.querySelector('[data-format="sample"]').hidden = answers[3] !== 'sample';
      this.querySelector('[data-format="travel"]').hidden = answers[3] !== 'travel';
      this.form.hidden = true;
      this.results.hidden = false;
      this.results.querySelector('h2').focus();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kierin-order-form"]) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-order-form]');
    if (!form) return;
    const messages = JSON.parse(root.querySelector('[data-messages]').textContent);
    const demo = root.dataset.demo === 'true';
    const ready = root.dataset.ready === 'true';
    const rows = [...root.querySelectorAll('[data-product-row]')].sort((a,b)=>Number(a.dataset.order)-Number(b.dataset.order));
    const fragranceHeaders=[];
    let lastFragrance='';
    rows.forEach(row=>{
      const parent=row.parentElement;
      if(!parent)return;
      if(row.dataset.fragrance!==lastFragrance){
        const heading=document.createElement('tr'),cell=document.createElement('th');
        heading.className='ko-fragrance-row';cell.colSpan=6;cell.textContent=row.dataset.fragrance;
        heading.appendChild(cell);parent.appendChild(heading);
        fragranceHeaders.push({heading,fragrance:row.dataset.fragrance});lastFragrance=row.dataset.fragrance;
      }
      parent.appendChild(row);
    });
    const status = root.querySelector('[data-status]');
    const submit = root.querySelector('[data-submit]');
    const cartLink = root.querySelector('[data-cart-link]');
    const money = cents => new Intl.NumberFormat('en-US', {style:'currency', currency:'USD'}).format(cents/100);
    const announce = (message,error=false) => {status.textContent=message;status.classList.toggle('ko-error',error);};
    const quantity = input => {
      const n=Number(input.value||0), min=Number(input.dataset.min), step=Number(input.dataset.step);
      if (!Number.isFinite(n)||n<0||n>100000||!Number.isInteger(n)) throw new Error(messages.invalid);
      if (n===0) return 0;
      const normalized=Math.ceil(Math.max(n,min)/step)*step;
      if (input.dataset.max&&normalized>Number(input.dataset.max)) throw new Error(messages.max);
      return normalized;
    };
    const recalc = () => {
      let cents=0,count=0;
      rows.forEach(row=>{
        const input=row.querySelector('[data-quantity]');
        const qty=input.disabled?0:Number(input.value||0);
        const value=Number.isFinite(qty)&&qty>=0?qty:0;
        const amount=value*Number(row.dataset.price);
        row.querySelector('[data-line-total]').textContent=value?money(amount):'—';
        row.setAttribute('aria-selected',String(value>0));
        cents+=amount;count+=value;
      });
      root.querySelector('[data-subtotal]').textContent=money(cents);
      root.querySelector('[data-total-qty]').textContent=String(count);
    };
    const normalize = input => {
      try {const previous=Number(input.value||0),q=quantity(input);input.value=String(q);input.setCustomValidity('');if(previous!==q) announce(messages.adjusted);else announce('');}
      catch(e){input.setCustomValidity(e.message);input.reportValidity();announce(e.message,true);}
      recalc();
    };
    rows.forEach(row=>{
      const input=row.querySelector('[data-quantity]');
      input.addEventListener('change',()=>normalize(input));
      input.addEventListener('input',()=>input.setCustomValidity(''));
      row.querySelector('[data-increase]').addEventListener('click',()=>{
        const current=Number(input.value||0),min=Number(input.dataset.min),step=Number(input.dataset.step);
        const next=current===0?min:current+step;
        if(input.dataset.max&&next>Number(input.dataset.max)){announce(messages.max,true);return;}
        input.value=String(next);normalize(input);
      });
      row.querySelector('[data-decrease]').addEventListener('click',()=>{
        const current=Number(input.value||0),min=Number(input.dataset.min),step=Number(input.dataset.step);
        input.value=String(current<=min?0:current-step);normalize(input);
      });
    });
    const search=root.querySelector('[data-search]'),format=root.querySelector('[data-format]');
    const filter=()=>{rows.forEach(row=>row.hidden=!(row.dataset.searchText.includes(search.value.trim().toLowerCase())&&(!format.value||format.value===row.dataset.format)));fragranceHeaders.forEach(({heading,fragrance})=>heading.hidden=!rows.some(row=>row.dataset.fragrance===fragrance&&!row.hidden));};
    search.addEventListener('input',filter);format.addEventListener('change',filter);
    const shipping=form.elements.shipping,pickup=root.querySelector('[data-pickup]');
    const taxChoice=form.elements['tax-choice'],taxDetails=root.querySelector('[data-tax-details]');
    const taxKeys={'tax-legal':'tax_legal','tax-address':'tax_address','tax-country':'tax_country','tax-region':'tax_region','tax-id':'tax_id','tax-form':'tax_form','tax-reason':'tax_reason','tax-scope':'tax_scope','tax-issued':'tax_issued','tax-expiry':'tax_expiry','tax-document':'tax_document','tax-signer':'tax_signer','tax-role':'tax_title_role','tax-signed-date':'tax_signed_date'};
    const taxMode=()=>{
      const active=taxChoice.value==='request';taxDetails.hidden=!active;taxDetails.disabled=!active;
      form.elements['tax-confirm'].setCustomValidity('');
      if(!active)form.elements['tax-ack'].checked=false;
    };
    taxChoice.addEventListener('change',taxMode);taxMode();
    const matchTaxIds=()=>{
      const mismatch=taxChoice.value==='request'&&form.elements['tax-id'].value.trim()!==form.elements['tax-confirm'].value.trim();
      form.elements['tax-confirm'].setCustomValidity(mismatch?messages.tax_mismatch:'');
      return !mismatch;
    };
    for(const name of ['tax-id','tax-confirm'])form.elements[name].addEventListener('input',matchTaxIds);
    const validateTax=()=>{
      if(!form.elements['tax-policy'].checked)throw new Error(messages.tax_policy_error);
      if(taxChoice.value!=='request')return;
      if(!matchTaxIds())throw new Error(messages.tax_mismatch);
      for(const name of [...Object.keys(taxKeys).filter(n=>n!=='tax-expiry'),'tax-confirm']){
        if(!form.elements[name].value.trim())throw new Error(messages.tax_required);
      }
      if(!form.elements['tax-ack'].checked)throw new Error(messages.tax_required);
      const now=new Date(),today=[now.getFullYear(),String(now.getMonth()+1).padStart(2,'0'),String(now.getDate()).padStart(2,'0')].join('-');
      const issued=form.elements['tax-issued'].value,signed=form.elements['tax-signed-date'].value,expiry=form.elements['tax-expiry'].value;
      if(issued>today||signed>today||(expiry&&expiry<issued))throw new Error(messages.tax_bad_date);
    };
    shipping.addEventListener('change',()=>{
      const isPickup=shipping.value==='exworks';pickup.hidden=!isPickup;
      for(const name of ['carrier','carrier-contact'])form.elements[name].required=isPickup;
    });
    root.querySelectorAll('[data-poster]').forEach(input=>input.addEventListener('change',()=>{
      if(Number(input.value)>0)root.querySelectorAll('[data-poster]').forEach(other=>{if(other!==input)other.value='0';});
    }));
    const api=async(path,body)=>{
      const response=await fetch(root.dataset.root+path,{method:body?'POST':'GET',credentials:'same-origin',headers:body?{'Content-Type':'application/json','Accept':'application/json'}:{'Accept':'application/json'},...(body?{body:JSON.stringify(body)}:{})});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description||result.message||messages.network);
      return result;
    };
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if(submit.disabled)return;
      try {
        rows.forEach(row=>{const input=row.querySelector('[data-quantity]');if(!input.disabled)input.value=String(quantity(input));});
        recalc();
        validateTax();
        if(!form.reportValidity())return;
        const selected=rows.filter(row=>!row.querySelector('[data-quantity]').disabled&&Number(row.querySelector('[data-quantity]').value)>0);
        if(!selected.length)throw new Error(messages.empty);
        const requests=[...root.querySelectorAll('[data-posm]')].filter(i=>Number(i.value)>0).map(i=>({label:messages['posm_'+i.dataset.posm],quantity:Number(i.value)}));
        if(requests.some(r=>!Number.isSafeInteger(r.quantity)||r.quantity<1||r.quantity>100000))throw new Error(messages.invalid);
        if([...root.querySelectorAll('[data-poster]')].filter(i=>Number(i.value)>0).length>1)throw new Error(messages.poster_error);
        if(demo){announce(messages.demo_done);status.focus();return;}
        if(!ready)throw new Error(messages.not_ready);
        submit.disabled=true;announce(messages.busy);cartLink.hidden=true;
        const before=await api('cart.js');
        if(before.currency!=='USD')throw new Error(messages.price_changed);
        if(before.item_count>0){cartLink.hidden=false;throw new Error(messages.existing_cart);}
        const expected=new Map(selected.map(row=>[String(row.dataset.variant),{quantity:Number(row.querySelector('[data-quantity]').value),price:Number(row.dataset.price)}]));
        const attributes={};
        const fields={buyer:'attr_buyer',email:'attr_email',phone:'attr_phone',po:'attr_po'};
        Object.entries(fields).forEach(([name,label])=>attributes[messages[label]]=form.elements[name].value.trim());
        attributes[messages.attr_source]='KIERIN Wholesale Order Request Form';
        attributes[messages.attr_tax_policy]=messages.tax_policy_ack;
        attributes[messages.attr_tax_request]=taxChoice.value==='request'?'Requested — supporting document receipt and exemption not verified':'No new exemption requested';
        attributes[messages.attr_tax_version]='2026-09-21-v1';
        attributes[messages.attr_tax_account]=root.dataset.customer||'';
        attributes[messages.attr_tax_location]=root.dataset.location||'';
        for(const [name,label] of Object.entries(taxKeys))attributes['Buyer-entered: '+messages[label]]=taxChoice.value==='request'?form.elements[name].value.trim():'';
        attributes[messages.attr_tax_ack]=taxChoice.value==='request'?messages.tax_ack:'';
        attributes[messages.attr_shipping]=shipping.value==='exworks'?messages.exworks:messages.paid;
        if(shipping.value==='exworks')for(const [name,label] of Object.entries({carrier:'attr_carrier',account:'attr_account','carrier-contact':'attr_carrier_contact',pickup:'attr_pickup'}))attributes[messages[label]]=form.elements[name].value.trim();
        attributes[messages.attr_posm]=requests.map(r=>`${r.quantity} × ${r.label}`).join('\n')||'—';
        attributes[messages.attr_notes]=form.elements.notes.value.trim();
        await api('cart/add.js',{items:[...expected].map(([id,data])=>({id:Number(id),quantity:data.quantity}))});
        const cart=await api('cart.js');
        if(cart.items.length!==expected.size||cart.items.some(item=>{const row=expected.get(String(item.variant_id));return !row||item.quantity!==row.quantity||item.original_price!==row.price;})){cartLink.hidden=false;throw new Error(messages.price_changed);}
        await api('cart/update.js',{attributes});
        location.assign(root.dataset.root+'checkout');
      } catch(error) {announce(error.message||messages.network,true);status.focus();cartLink.hidden=demo;}
      finally {submit.disabled=false;}
    });
    submit.disabled=!(demo||ready)||!rows.some(row=>!row.querySelector('[data-quantity]').disabled);
    if(!rows.length)announce(messages.no_products,true);
    recalc();
  }
  document.querySelectorAll('[data-kierin-order]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-kierin-order]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kierin-wholesale-shop"]) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.wsInit) return;
    root.dataset.wsInit = '1';
    const rows = [...root.querySelectorAll('[data-ws-row]')];
    if (!rows.length) return;

    const reviewButtons = [...root.querySelectorAll('[data-ws-review]')];
    const panel = root.querySelector('[data-ws-review-panel]');
    const reviewLines = root.querySelector('[data-ws-review-lines]');
    const subtotalEl = root.querySelector('[data-ws-subtotal]');
    const unitsEl = root.querySelector('[data-ws-total-units]');
    const status = root.querySelector('[data-ws-status]');
    const submit = root.querySelector('[data-ws-submit]');
    const back = root.querySelector('[data-ws-back]');
    const topSelection = root.querySelector('[data-ws-selection]');
    const bottomSelection = root.querySelector('[data-ws-selection-bottom]');
    const money = cents => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents/100);

    root.querySelectorAll('tbody').forEach(tbody => {
      [...tbody.querySelectorAll('[data-ws-row]')]
        .sort((a,b) => a.dataset.name.localeCompare(b.dataset.name))
        .forEach(row => tbody.appendChild(row));
    });

    const normalize = input => {
      let n = Number(input.value || 0);
      const min = Number(input.dataset.min || 1);
      const step = Number(input.dataset.step || 1);
      if (!Number.isFinite(n) || n <= 0) return 0;
      n = Math.max(n,min);
      n = min + Math.ceil((n-min)/step)*step;
      if (input.dataset.max) n = Math.min(n,Number(input.dataset.max));
      return Math.round(n);
    };

    const selectedRows = () => rows.filter(row => Number(row.querySelector('[data-ws-qty]').value || 0) > 0);

    const recalc = () => {
      let subtotal = 0, units = 0;
      rows.forEach(row => {
        const input = row.querySelector('[data-ws-qty]');
        const qty = Number(input.value || 0);
        const amount = qty * Number(row.dataset.price || 0);
        row.querySelector('[data-ws-line]').textContent = qty ? money(amount) : '—';
        row.dataset.selected = String(qty > 0);
        subtotal += amount;
        units += qty;
      });
      const count = selectedRows().length;
      const label = count ? `${count} item${count===1?'':'s'} selected · ${units} units · ${money(subtotal)}` : 'Nothing selected yet.';
      if (topSelection && topSelection.textContent !== label) topSelection.textContent = label;
      if (bottomSelection) bottomSelection.textContent = label;
      reviewButtons.forEach(b => b.disabled = count === 0);
      return {subtotal,units,count};
    };

    rows.forEach(row => {
      const input = row.querySelector('[data-ws-qty]');
      row.querySelector('[data-ws-plus]').addEventListener('click',() => {
        const current = Number(input.value || 0);
        const min = Number(input.dataset.min || 1);
        const step = Number(input.dataset.step || 1);
        input.value = String(current <= 0 ? min : current + step);
        if (input.dataset.max) input.value = String(Math.min(Number(input.value),Number(input.dataset.max)));
        recalc();
      });
      row.querySelector('[data-ws-minus]').addEventListener('click',() => {
        const current = Number(input.value || 0);
        const min = Number(input.dataset.min || 1);
        const step = Number(input.dataset.step || 1);
        input.value = String(current <= min ? 0 : Math.max(min,current-step));
        recalc();
      });
      input.addEventListener('change',() => {
        input.value = String(normalize(input));
        recalc();
      });
    });

    let reviewTrigger = null;
    const scrollBehavior = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
    const renderReview = event => {
      reviewTrigger = event.currentTarget;
      const selected = selectedRows();
      reviewLines.innerHTML = '';
      let subtotal = 0, units = 0;
      selected.forEach(row => {
        const qty = Number(row.querySelector('[data-ws-qty]').value);
        const amount = qty * Number(row.dataset.price);
        subtotal += amount; units += qty;
        const line = document.createElement('div');
        line.className = 'ws-review-line';
        line.innerHTML = `<span><strong>${row.dataset.name}</strong><br><small>${row.dataset.sku}</small></span><span>${qty} units</span><strong>${money(amount)}</strong>`;
        reviewLines.appendChild(line);
      });
      subtotalEl.textContent = money(subtotal);
      unitsEl.textContent = String(units);
      panel.hidden = false;
      panel.focus({preventScroll:true});
      panel.scrollIntoView({behavior:scrollBehavior(),block:'start'});
    };

    reviewButtons.forEach(btn => btn.addEventListener('click',renderReview));
    back.addEventListener('click',() => {
      panel.hidden = true;
      const target = reviewTrigger || reviewButtons[0];
      if (target) {
        target.focus({preventScroll:true});
        target.scrollIntoView({behavior:scrollBehavior(),block:'center'});
      }
    });

    const api = async(path, body) => {
      const response = await fetch(root.dataset.root + path,{
        method:body?'POST':'GET',
        credentials:'same-origin',
        headers:body?{'Content-Type':'application/json','Accept':'application/json'}:{'Accept':'application/json'},
        ...(body?{body:JSON.stringify(body)}:{})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to continue. Please try again.');
      return result;
    };

    submit.addEventListener('click', async() => {
      try {
        status.textContent = '';
        status.classList.remove('ws-error');
        rows.forEach(row => {
          const input = row.querySelector('[data-ws-qty]');
          input.value = String(normalize(input));
        });
        const selected = selectedRows();
        if (!selected.length) throw new Error('Select at least one item before submitting your request.');
        submit.disabled = true;
        status.textContent = 'Preparing your wholesale request…';

        const before = await api('cart.js');
        if (before.item_count > 0) throw new Error('Your cart already contains items. Please clear the cart before starting a wholesale request.');

        const items = selected.map(row => ({
          id:Number(row.dataset.variant),
          quantity:Number(row.querySelector('[data-ws-qty]').value),
          properties:{'_KIERIN Wholesale Request':'Yes'}
        }));
        await api('cart/add.js',{items});

        const attributes = {
          'Wholesale Source':'KIERIN Wholesale Assortment',
          'Wholesale Company':root.dataset.company || '',
          'Wholesale Location':root.dataset.location || '',
          'PO Number':root.querySelector('[data-ws-po]').value.trim(),
          'Freight Preference':root.querySelector('[data-ws-freight]').value,
          'Promotional Support Preference':root.querySelector('[data-ws-posm]').value,
          'Wholesale Notes':root.querySelector('[data-ws-notes]').value.trim()
        };
        await api('cart/update.js',{attributes});
        window.location.assign(root.dataset.root + 'checkout');
      } catch (error) {
        status.textContent = error.message || 'Unable to continue. Please try again.';
        status.classList.add('ws-error');
        submit.disabled = false;
      }
    });

    recalc();
  };

  document.querySelectorAll('[data-wholesale-shop]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-wholesale-shop]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
